import TomSelect from 'tom-select/dist/esm/tom-select.js';

$(document).ready(() => {
    if ($('.js-page-size').length) {
        initPageSizeSelect();
    }

    if ($('.js-activity-type-select').length) {
        initActivityTypeSelect();
    }
});

function initPageSizeSelect() {
    new TomSelect('.js-page-size', {
        create: false,
        sortField: {
            field: "text",
            direction: "asc"
        },
        controlInput: null,
        render: {
            option: function (data) {
                return '<div class="radio">' +
                    '<input id="radio-' + data.text + '" name="radio" type="radio" tabindex="-1"' + (this.items[0] === data.text ? 'checked' : '') + '>' +
                    '<label for="radio-' + data.text + '" class="radio-label">' + data.text + '</label>' +
                    '</div>';
            },
        }
    });

    $('.js-page-size.tom-select .ts-control').append('<span class="icon icon-arrow-down ml-3"></span><span class="icon icon-arrow-up ml-3"></span>');
}

function initActivityTypeSelect() {
    new TomSelect('.js-activity-type-select', {
        create: false,
        sortField: {
            field: "text",
            direction: "asc"
        },
        controlInput: null,
        allowEmptyOption: true,
        render: {
            option: function (data) {
                if(data.disabled)
                    return '<div class="option d-none">' +
                        '<span class="option-text">' + data.text + '</span>' +
                        '<div class="icon icon-checked"></div>' +
                        '</div>';
                return '<div class="option">' +
                    '<span class="option-text">' + data.text + '</span>' +
                    '<div class="icon icon-checked"></div>' +
                    '</div>';
            },
        }
    });

    $('.js-activity-type-select.tom-select .ts-control').append('<span class="icon icon-arrow-down ml-3"></span><span class="icon icon-arrow-up ml-3"></span>');
}
